var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-layout page-layout--default pb-12",class:("page-layout--bg-" + (this.backgroundColor))},[_c('the-header'),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }